function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconXlink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m22 5.2-.1.1-8.5 8.7c-1 1-1 2.5 0 3.5l1.2 1.2c1 1 2.5 1 3.5 0l8.5-8.7.1-.1 2.6 2.7c1 1 1.7.6 1.7-.7V1.8c0-.4-.4-.8-.8-.8h-9.8c-1.4 0-1.7.8-.7 1.8zM6 1C3.2 1 1 3.2 1 6v20c0 2.8 2.2 5 5 5h20c2.8 0 5-2.2 5-5V13.1v7.1L26 16v7.5c0 1.4-1.1 2.5-2.5 2.5h-15C7.1 26 6 24.9 6 23.5v-15C6 7.1 7.1 6 8.5 6H16l-4.2-5h7.1z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
}));
export default SvgIconXlink;